export const COLORS = {
  RED: '#eb0043',
  GREEN: '#00be70',
  ORANGE: '#ef6902',
  BLUE: '#599afe',
}

export const POSITIONS = {
  TOP: 'top',
  LEFT: 'left',
  CENTER: 'center',
  BOTTOM: 'bottom',
}

export const TOAST_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
  WARN: 'warn',
}

export const DEFAULT_OPTIONS = {
  gravity: POSITIONS.TOP,
  position: POSITIONS.CENTER,
  escapeMarkup: false,
  offset: {
    x: 0,
    y: -5,
  },
  style: {
    background: COLORS.GREEN,
  },
}

export const TOASTS = {
  [TOAST_TYPES.SUCCESS]: DEFAULT_OPTIONS,
  [TOAST_TYPES.ERROR]: {
    ...DEFAULT_OPTIONS,
    style: {
      background: COLORS.RED,
    },
  },
  [TOAST_TYPES.INFO]: {
    ...DEFAULT_OPTIONS,
    style: {
      background: COLORS.BLUE,
    },
  },
  [TOAST_TYPES.WARN]: {
    ...DEFAULT_OPTIONS,
    style: {
      background: COLORS.ORANGE,
    },
  },
}

export const TOAST_CLASS = 'data-testid-toast'
